import { useRouter } from 'vue-router'
import { reactive, watch, onBeforeMount, onMounted, computed } from 'vue';
import Button from '@/components/ui/button/index.vue';
import Table from '@/components/ui/tablebox/index.vue';
import TableInfo from '@/components/ui/tableinfo/index.vue';
import Select from '@/components/ui/select/index.vue';
import CTmenu from '@/components/ui/ctmenu/index.vue';
import Pagination from '@/components/ui/pagination/index.vue';
import ActionBar from '@/components/ui/actionbar/index.vue';
import Dropdown from '@/components/ui/dropdown/index.vue';
import { ACTIONBAR, POPUP, BTN, FEATURENAME, CONNECTION } from '@/enum/enum';
import { useStore } from 'vuex';
import { apiGroup, apiDeleteGroup, apiGroupNameAdd, apiGetGroupModel, apiCSV, apiGetDevice, apiAddDevice } from '@/api/api';
import { dateTimeHandle } from '@/utils/time';
import { useI18n } from 'vue-i18n';
// import { idText } from 'typescript';



export default {
  name: 'group',
  components: {
    Button,
    Select,
    Table,
    TableInfo,
    CTmenu,
    Pagination,
    ActionBar,
    Dropdown
  },
  props: {
    // tabText:{  
    // }
  },
  setup() {

    const { t } = useI18n();

    const state = reactive({
      hasAdd : false,
      newGroupID : '',
      modalList : [],
      opDL: [
        {
          text: t('__common.__all'),
          val: '',
          isI18n: '__common.__all',
        },
        {
          text: t('__d7d_n17r.__connectionStatus'),
          val: 'connection',
          isI18n: '__d7d_n17r.__connectionStatus',
          sub: [
            {
              text: t('__g3p_m8t.__online'),
              val: '1',
              isI18n : '__g3p_m8t.__online',
            },
            {
              text: t('__g3p_m8t.__offline'),
              val: '0',
              isI18n : '__g3p_m8t.__offline',
            }
          ]
        },
      ],
      unbindOp: ["Ungroup only", "Ungroup and unbind devices"],

      meta: {
        total_page: 1,
        current: 1,
        per_page: 0,
      },

      options: [{
        text: t('__g3p_m8t.__allGroup'),
        val: '',
        isI18n: '__g3p_m8t.__allGroup',
      },
      {
        text: t('__common.__model'),
        val: 'model',
        isI18n: '__common.__model',
        sub: []
      },
      ],
      selectVal: {
        text: t('__g3p_m8t.__allGroup'),
        val: '',
        isI18n: '__g3p_m8t.__allGroup',
      },
      dataList: [],
      iconList: [
        {
          title: t('__d4e_m8t.__setCalibration'),
          name: 'asus_proart_sw_ico_control_settings',
          val: ACTIONBAR.SETCAL,
          disabled: true,
          isI18n: '__d4e_m8t.__setCalibration',
          gtmId : '__setCalibrationGroupIcon',
        },
        {
          title: t('__d4e_m8t.__viewHistory'),
          name: 'asus_pacc_sw_ico_history',
          val: ACTIONBAR.VIEWHIS,
          disabled: true,
          isI18n: '__d4e_m8t.__viewHistory',
          gtmId : '__viewHistoryGroupIcon',
        },
        {
          title: t('__d4e_m8t.__viewAppointment'),
          name: 'asus_pacc_sw_ico_appointment',
          val: ACTIONBAR.VIEWAPP,
          disabled: true,
          isI18n: '__d4e_m8t.__viewAppointment',
          gtmId : '__viewAppointmentGroupIcon',
        },
        {
          title: t('__d4e_m8t.__settings'),
          name: 'asus_proart_sw_ico_settings',
          val: ACTIONBAR.SETTING,
          disabled: true,
          isI18n: '__d4e_m8t.__settings',
          gtmId : '__settingsGroupIcon',
        },
        {
          title: t('__d4e_m8t.__downloadCsv'),
          name: 'asus_proart_sw_ico_download',
          val: ACTIONBAR.DOWNLOAD,
          disabled: true,
          isI18n: '__d4e_m8t.__downloadCsv',
          gtmId : '__downloadCsvGroupIcon',
        },
      ],
      ctList: [
        {
          title: t('__d4e_m8t.__setCalibration'),
          name: 'asus_proart_sw_ico_control_settings',
          val: ACTIONBAR.SETCAL,
          disabled: true,
          isI18n: '__d4e_m8t.__setCalibration',
          gtmId : '__setCalibrationCTGroup',
        },
        {
          title: t('__d4e_m8t.__viewHistory'),
          val: ACTIONBAR.VIEWHIS,
          disabled: true,
          isI18n: '__d4e_m8t.__viewHistory',
          gtmId : '__viewHistoryCTGroup',
        },
        {
          title: t('__d4e_m8t.__viewAppointment'),
          val: ACTIONBAR.VIEWAPP,
          disabled: true,
          isI18n: '__d4e_m8t.__viewAppointment',
          gtmId : '__viewAppointmentCTGroup',
        },
        {
          title: t('__d4e_m8t.__settings'),
          val: ACTIONBAR.SETTING,
          disabled: true,
          isI18n: '__d4e_m8t.__settings',
          gtmId : '__settingsCTGroup',
        },
        {
          title: t('__d4e_m8t.__downloadCsv'),
          val: ACTIONBAR.DOWNLOAD,
          disabled: true,
          isI18n: '__d4e_m8t.__downloadCsv',
          gtmId : '__downloadCsvCTGroup',
        },
        {
          title: t('__g3p_m8t.__ungroupOnly'),
          val: ACTIONBAR.UNGROUP,
          disabled: true,
          isI18n: '__g3p_m8t.__ungroupOnly',
          gtmId : '__ungroupOnlyCTGroup',
        },
        {
          title: t('__g3p_m8t.__ungroupAndUnbindDevices'),
          val: ACTIONBAR.UNGROUPANDUNBIND,
          disabled: true,
          isI18n: '__g3p_m8t.__ungroupAndUnbindDevices',
          gtmId : '__ungroupAndUnbindDevicesCTGroup',
        },
      ],
      list: [],
      modalGetData: '',
      btnDisabled: {
        disBind: true,
      },

      order: 'asc',
      sort: 'created_at',
      listTotal: null,



    })

    const route = useRouter()
    const fatherLink = route.currentRoute.value.fullPath


    const actionBarClick = (v) => {
      // console.log(v,'actionBar Click')
      if (v == ACTIONBAR.SETTING || v == ACTIONBAR.VIEWAPP || v == ACTIONBAR.VIEWHIS) {
        toLink(v)
      } else if (v == ACTIONBAR.SETCAL) {
        toCalibration()
      } else if (v == ACTIONBAR.DOWNLOAD) {
        geCVS()
      } else if (v == ACTIONBAR.UNGROUPANDUNBIND || ACTIONBAR.UNGROUP) {
        dropdownList({ value: v })
      }
    }

    onMounted(() => {
    })

    onBeforeMount(() => {
      queryModels();
      getData();
    })


    watch(  //觀測勾選項目
      () => state.list,
      (val) => {
        if (val.length > 0) { // action bar
          if (val.length > 1 || val.length < 1) {
            for (let i = 0; i < state.iconList.length; i++) {
              if (i == 1 || i == 2 || i == 3) {
                state.iconList[i].disabled = true
              }
              else {
                state.iconList[i].disabled = false
              }
            }
          }
          else {
            for (let i = 0; i < state.iconList.length; i++) {
              state.iconList[i].disabled = false
            }
          }
        } else {
          for (let i = 0; i < state.iconList.length; i++) {
            state.iconList[i].disabled = true
          }
        }
        //ctList
        if (val.length > 0) { // action bar

          if (val.length > 1 || val.length < 1) {
            for (let i = 0; i < state.ctList.length; i++) {
              if (i == 1 || i == 2 || i == 3) {
                state.ctList[i].disabled = true
              }
              else {
                state.ctList[i].disabled = false
              }
            }
          }
          else {
            for (let i = 0; i < state.ctList.length; i++) {
              state.ctList[i].disabled = false
            }
          }
        } else {
          for (let i = 0; i < state.ctList.length; i++) {
            state.ctList[i].disabled = true
          }
        }

      },
      { deep: true }
    )


    const column = computed(() => {
      return [
        {
          title: t('__g3p_m8t.__groupName'),
          key: "name",
          isLink: true,
          sort: true,
        },
        {
          title: t('__d7d_n17r.__modelName'),
          key: "model",
          sort: true,

        },
        {
          title: t('__g3p_m8t.__deviceAmount'),
          key: "device_count",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__connectionStatus') + ' (' + t('__g3p_m8t.__online') + ' /' + t('__g3p_m8t.__offline') + ')' ,
          key: "connection",
        },
        {
          title: t('__g3p_m8t.__dateCreated'),
          key: "created_at",
          sort: true,
        },
      ]
    })

    //multi lang  
    const unbindOp = computed(
      () => [t('__g3p_m8t.__ungroupOnly'), t('__g3p_m8t.__ungroupAndUnbindDevices')],
    );

    const geCVS = async () => {

      let id = [];
      id = state.list.map((e) => {
        let arr = []
        arr = e.devices.map((each) => {
          return each.id
        })
        return arr
      })

      let merged = [].concat.apply([], id); //二維陣列整合成一維
      let uni = Array.from(new Set(merged)); //去除重複的值
      console.log(uni, 'whyyyy', id)
      const sendData = {
        id: uni,
      }
      try {
        const datas = await apiCSV(sendData);
        console.log('apiCSV', datas)
        let date = dateTimeHandle(new Date(), "YYYYMMDD_HHmm", "YYYYMMDD_HHmm")
        const url = window.URL.createObjectURL(new Blob([datas]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${date}.csv`);
        document.body.appendChild(link);
        link.click();
      }
      catch (error) {
        return error;
      }
    }



    const getData = async () => {
      if(state.listTotal && state.hasAdd) { //新增後直接導向該page頁面
        let addToPage = Math.floor((state.listTotal ) /12)
        if(addToPage){
          state.meta.current = 1 + addToPage
        }
      }

      // if()

      const sendData = {
        page: state.meta.current,
        model: state.selectVal.val,
        order: state.order,
        sort: state.sort,
        status: '',
        per_page: state.meta.per_page,
      }
      state.hasAdd = false;
      try {
        const datas = await apiGroup(sendData);
        console.log('apiGroup', datas)
        if (!datas.status_code) {
          for (let i = 0; i < datas.data.length; i++) {
            datas.data[i].connection = `${datas.data[i].device_online_count} / ${datas.data[i].device_offline_count}`

            if (datas.data[i].created_at) {
              datas.data[i].created_at = dateTimeHandle(datas.data[i].created_at);
            } else {
              datas.data[i].created_at = ''
            }
          }

          state.dataList = datas.data;
          state.meta.current = datas.current_page;
          state.meta.total_page = datas.last_page;
          state.meta.per_page = datas.per_page;
          state.listTotal = datas.total
          let arr = [];
          for (let j = 0; j < datas.models.length; j++) {
            arr.push({ text: datas.models[j], val: datas.models[j] })
            state.options[1].sub = arr
          }
        }


      }
      catch (error) {
        return error;
      }

    }

    const deleteGroup = async (output) => {
      const sendData = {
        id: output.arr,
        unbind: output.action
      }
      try {
        const datas = await apiDeleteGroup(sendData);
        console.log('apiDeleteGroup', datas)

        if(state.dataList.length == output.arr.length) state.meta.current -=1
        getData()
        state.list.splice(0, state.list.length)
      }
      catch (error) {
        return error;
      }

    }


    const queryModels = async () => {
      try {
        const datas = await apiGetGroupModel();
        if (!datas.status_code) {
          let arr = [];
          for (let j = 0; j < datas.model.length; j++) {
            arr.push({ text: datas.model[j], val: datas.model[j] })
            state.options[1].sub = arr
          }
        }
      }
      catch (error) {
        return error;
      }
    }


    const selectChange = (v) => {
      if (v) {
        state.meta.current = 1
        getData()
      }
    }





    const toCalibration = () => {
      let result = state.list.every(val => val.model === state.list[0].model);
      // let arr = state.list.map((e)=>{
      //   return e.id
      // })
      if (result) {
        console.log('確認',state.list)
        store.commit('setCalibrationList', { content: state.list, title: 'group', next: state.list[0].devices }); 
        console.log('送出的資料',store.state.calibrationList)
        route.push({ name: FEATURENAME.CALIBRATION });
      } else {
        const modalConfig = {
          type: POPUP.DEVICEMODELERROR,
          data: {
            actionFlag: 'goCalibration',
          },
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)
      }

    }



    const changePage = (page) => {
      // console.log('uu',page)
      state.meta.current = page;
      getData()
    }
    const tableSort = (v) => {
      // console.log(v,'sort table')
      state.order = v.val === 'up' ? 'asc' : 'desc';
      state.sort = v.key;
      getData()
    }

    const onCheckAll = (v) => {
      // console.log(v, 'table onCheck All')
      state.list = v
    }

    const onCheckEach = (v) => {
      // console.log(v, 'table onCheck Each')
      state.list = v
    }

    const goTableLink = (v) => {
      // console.log(v,'table link')
      // let urlName = v.val.name.replace(' ', "")
      // urlName = urlName.replace(' ', "")

      route.push(`${fatherLink}/${v.val.id}/${ACTIONBAR.DEVICELIST}`);
    }

    const showCTAndRow = (v) => {
      // console.log(v,'show ??? ContextMenu')
      state.list = v.list
    }

    const selectCT = (v) => {
      actionBarClick(v.val)
    }


    const toLink = (v) => {
      // let urlName = state.list[0].name.replace(' ', "")
      // urlName = urlName.replace(' ', "")

      route.push({
        path: `${fatherLink}/${state.list[0].id}/${v}`,
        query: {
          gName: state.list[0].name,
        },
      });
      // route.push(`${fatherLink}/${state.list[0].id}/${v}`);
    }










    //modal

    const store = useStore()
    const storeState = store.state;

    const openModalCreate = () => {
      let arr = []
      state.dataList.forEach((e) => {  //檢查名字是否一樣
        arr.push(e.groupName)
      })
      const modalConfig = {
        type: POPUP.GROUPADD,
        data: {
          totalLength: state.listTotal,
          arr,
        },
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }


    const dropdownList = (v) => {
      console.log(v)
      let unbindOp = {
        1: "unbind",
        0: "ungroup"
      }
      let modalConfig = {}
      switch (unbindOp[v]) {
        case 'unbind':
          console.log('?')
          modalConfig = {
            type: POPUP.UNBIND,
            data: {
              list: state.list,
              action: unbindOp[v.value] == 'unbind' ? true : false
            },
            isShow: true,
          }
          store.commit('setIsShowModal', modalConfig)
          break;

        case 'ungroup':
          modalConfig = {
            type: POPUP.UNGROUP,
            data: {
              list: state.list,
              action: unbindOp[v.value] == 'unbind' ? true : false
            },
            isShow: true,
          }
          store.commit('setIsShowModal', modalConfig)
          break;

      }

    }




    const groupNameAdd = async (output) => { //待後端補新增
      const sendData = {
        name: output,
      }
      try {
        const datas = await apiGroupNameAdd(sendData);
        console.log('apiGroupNameAdd', datas)
        
        getNewGroupName(output) //tbdddddd
        
      }
      catch (error) {
        return error;
      }
    }

    const getNewGroupName = async (output) => { //待後端補新增
      try {
        const datas = await apiGetGroupModel();
        console.log('apiGetGroupModel list', datas)
        for (let i = 0; i < datas.groups.length; i++) {
          if(datas.groups[i].name == output){
            modalDeviceList()
            state.newGroupID  = datas.groups[i].id
          }
        }

      }
      catch (error) {
        return error;
      }
    }

    const modalColumn = computed(() => {
      return [
        {
          title: t('__g3p_m8t.__serialNumber'),
          key: "ssn",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "host",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__connectionStatus'),
          key: "status",
          color: true,  // 是否有客製化顏色，有的話直接讀取data值作為class名稱
          colorEnum:
          {
              0: CONNECTION[0],
              1: CONNECTION[1],
              2: CONNECTION[2],
          },
          isI18n:
            {
              0: '__g3p_m8t.__offline',
              1: '__g3p_m8t.__online',
              2: '__g3p_m8t.__waiting',
            },
          sort: true,
        },
        {
          title: t('__d7d_n17r.__ipAddress'),
          key: "ip",
          sort: true,
        },

        // {
        //   title: "Connection Status", 
        //   key: "connectionStatus", 
        //   color: true,
        // },
        // {
        //   title: "Implementation status", 
        //   key: "Implementation status", 
        //   color: true,
        // },
        // {
        //   title: "Report", 
        //   key: "report", 
        //   customRender: "report",
        // },
      ]
    })


    const modalDeviceList = async () => { //呼叫add device popup
      let defaultModel =  ' ';
      let selectDisable =  false ;
      const maxNum = Number.MAX_SAFE_INTEGER;
      const sendData = {
        per_page: maxNum,
        model: undefined,
      }
      try {
        const datas = await apiGetDevice(sendData);
        console.log('apiGetDevice modal', datas.data)
        state.modalList = datas.data;


        state.modalList = state.modalList.filter((e) => {  //model 為null的話不顯示
          return e.model
        })
        state.modalList = state.modalList.filter((e) => {  //model 狀態為waiting的話不顯示
          return e.status != 2
        })

        // console.log(defaultModel,'外面',state.modelOption)
        const modalConfig = {
          type: POPUP.DEVICEDETAIL,
          data: {
            selectDisable,  //下拉選單是否 disable
            defaultModel,  //有沒有預先選擇的model
            col: modalColumn,
            list: state.modalList,
            selectModel: state.options[1].sub,
            selectStatus: state.opDL,
            compareList: [],
          },
          isShow: true,
        }

        store.commit('setIsShowModal', modalConfig)
        // apiPost() //tbdddddd
      }
      catch (error) {
        return error;
      }
    }


    const addDevice = async (output) => {
      const groupId = state.newGroupID
      let id = []
      id = output.map(item => item.id);
      const sendData = {
        id: id,
      }
      try {
        const datas = await apiAddDevice(groupId, sendData);
        console.log('apiDeleteGroupDevice', datas)
        state.hasAdd = true;
        getData()
      }
      catch (error) {
        if (error.response.data.status_code == 6) {

          // let devices = [  //local測試用
          //   "PA329AC_AA1500072-PC",
          //   "PA329AC_AA1500072-PC"
          // ]
          // console.log('?????',error.response.data.status_code)
          const modalConfig = {
            type: POPUP.OVERFLOW,
            data: {
              list: error.response.data.devices,//
            },
            isShow: true,
          }

          store.commit('setIsShowModal', modalConfig)
          // if()
        }

        return error;
      }
    }






    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.GROUPADD) {
        console.log('storeState.modalBtnType', storeState.modalBtnType);
        // modal btn type 決定要幹嘛
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput
          console.log(output)
          groupNameAdd(output)
        }
      } else if (oldType === POPUP.UNGROUP || oldType === POPUP.UNBIND) {
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput;
          // console.log(output,'output')
          deleteGroup(output)
        }
      } else if (oldType === POPUP.DEVICEDETAIL) {
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput;
          // addDevice(output) //等等刪
          let resultArr = output.map((e) => {
            return e.model
          })
          let arr = Array.from(new Set(resultArr))
          console.log('addDevice output', arr)
          if (arr.length > 1) {
            const modalConfig = {
              type: POPUP.DEVICEMODELERROR,
              data: {
                actionFlag: 'createNewGroup',
              },
              isShow: true,
            }

            store.commit('setIsShowModal', modalConfig)
          } else {
            addDevice(output)
          }
        }else{
          state.hasAdd = true;
          getData()
        }
      } else if (oldType === POPUP.DEVICEMODELERROR) {
        const output = storeState.modalOutput;
        console.log('output??????',output)
        console.log('toreState.modalBtnType', storeState.modalBtnType);
        if(output == 'createNewGroup') modalDeviceList()
      } else if (oldType === POPUP.OVERFLOW) {
        // console.log('toreState.modalBtnType', storeState.modalBtnType);
        modalDeviceList()
      }
    })



    return {
      state,
      tableSort,
      onCheckAll,
      onCheckEach,
      goTableLink,
      showCTAndRow,
      selectCT,
      changePage,
      actionBarClick,
      openModalCreate,
      dropdownList,
      toLink,
      toCalibration,
      groupNameAdd,
      queryModels,
      selectChange,
      geCVS,
      t,
      column,
      unbindOp,
      modalDeviceList,
      modalColumn,
      addDevice,
      getNewGroupName
      // getStatisticReport
    }
  }// end: setup

}


